export const ContactSalesComponentPTBRTranslations = {
  contactSalesTitle:
    'Use dados e previsões baseadas em IA para impulsionar seu negócio',
  contactSalesCallout: 'COMECE GRÁTIS',
  contactSalesDescription:
    'Saiba como podemos melhorar as tomadas de decisões e os resultados da sua empresa agendando uma ligação online com um de nossos especialistas',
  contactSalesBackgroundAlt: 'Fale com vendas imagem de fundo',
};
